export const removeOldBoundaryLayers = (regions, regionsMpbn, map) => {
  // Remove previous fill and line layers and sources for regions
  [...regions, ...regionsMpbn].forEach((region) => {
    const fillLayerId = region.id;
    const lineLayerId = `${region.id}-border`;

    if (map.current.getLayer(lineLayerId)) {
      map.current.removeLayer(lineLayerId);
    }
    if (map.current.getLayer(fillLayerId)) {
      map.current.removeLayer(fillLayerId);
    }
    if (map.current.getSource(region.id)) {
      map.current.removeSource(region.id);
    }
  });
};
